module.exports = __webpack_public_path__ + "static/media/step3_14.954cad26.png";